<template lang="html">
<section class="admin">
    <ManageUsers />
    <ManageSegments />
    <TestDevices />

</section>
</template>

<script lang="js">
import ManageUsers from '@/components/ManageUsers.vue'
import ManageSegments from '@/components/ManageSegments.vue'
import TestDevices from '@/components/TestDevices.vue'

export default {
    name: 'admin',
    props: [],
    components: {
        ManageUsers,
        ManageSegments,
        TestDevices
    },
    mounted() {

    },
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
.admin {}
</style>
